import { render, staticRenderFns } from "./VitaProtezione.vue?vue&type=template&id=78bd4763&scoped=true&"
import script from "./VitaProtezione.vue?vue&type=script&lang=ts&"
export * from "./VitaProtezione.vue?vue&type=script&lang=ts&"
import style0 from "./VitaProtezione.vue?vue&type=style&index=0&id=78bd4763&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bd4763",
  null
  
)

export default component.exports